export default {
  root: {
    class: [
      'flex',
      'flex-row',
      'justify-between',
      'items-center',
      'overflow-hidden',

      'rounded-md',
      'shadow-card',

      'bg-blueAdditional-blue-grey',
      'text-surface-700',
      'p-1',

      'border',
      'border-brand-blue',
    ],
  },
  listcontainer: {
    class: [
      'rounded',
      'gap-2',
      'shadow-lg',
      'bg-blueAdditional-blue-grey',
      'text-surface-700',
      'overflow-auto',
      '!max-h-128',
    ],
  },
  option: {
    class: [
      'rounded',
      'pl-1',
      'py-0.5',
      'hover:bg-blue-500',
      'hover:text-white',
    ],
  },
  option: {
    class: [
      'rounded',
      'pl-1',
      'py-0.5',
      'hover:bg-blue-500',
      'hover:text-white',
    ],
  },
  loader: {
    class: ['!hidden'],
  },
}
